<template>
  <TheGreyWrapper>
    <TheHeader
      :back-route="computedBackRoute"
      force-sm-style
    />
    <BaseSection>
      <BaseTitleGroup
        :title="$t(entityId ? 'Investment entity edit' : 'Investment entity creation')"
        :subtitle="opportunity && opportunity.data.attributes.name"
        class="mb-8"
      />
      <form @submit.prevent="submit()">
        <BaseInputGroup
          v-model="firstname"
          :label="$t('Firstname')"
          type="text"
          class="mb-4"
          autofocus
          required
        />
        <BaseInputGroup
          v-model="lastname"
          :label="$t('Lastname')"
          type="text"
          class="mb-4"
          required
        />
        <BaseInputGroup
          v-model="address"
          :label="$t('Address')"
          type="text"
          class="mb-4"
          required
        />
        <BaseInputGroup
          v-model="zipCode"
          :label="$t('Zip code')"
          type="text"
          pattern="[0-9]+"
          class="mb-4"
          required
        />
        <BaseInputGroup
          v-model="city"
          :label="$t('City')"
          type="text"
          class="mb-4"
          required
        />
        <BaseSelect
          v-model="country"
          :label="$t('Country')"
          :options="countries"
          track-by="code"
          select-label="name"
          value-property="code"
          class="mb-4"
          required
        />
        <BaseInputGroup
          v-model="birthDate"
          :label="$t('Birth date')"
          type="text"
          class="mb-12"
          required
        />
        <BaseInputGroup
          v-model="birthCity"
          :label="$t('Birth city')"
          type="text"
          class="mb-12"
          required
        />
        <BaseSelect
          v-model="birthCountry"
          :label="$t('Birth country')"
          :options="countries"
          track-by="code"
          select-label="name"
          value-property="code"
          class="mb-4"
          required
        />
        <BaseButton
          :title="$t('Confirm')"
          class="mb-8"
        />
      </form>
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import loadOpportunity from '../mixins/loadOpportunity';
import investmentEntityCreation from '../mixins/investmentEntityCreation';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseInputGroup from '../components/BaseInputGroup.vue';
import BaseButton from '../components/BaseButton.vue';
import BaseSelect from '../components/BaseSelect.vue';
import TheHeader from '../components/TheHeader.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';

export default {
  name: 'InvestmentEntityPersonCreation',
  components: {
    BaseSection,
    BaseTitleGroup,
    TheHeader,
    BaseInputGroup,
    BaseButton,
    TheGreyWrapper,
    BaseSelect,
  },
  mixins: [loadOpportunity, investmentEntityCreation],
  computed: mapFields('investmentEntity', [
    'form.firstname',
    'form.lastname',
    'form.address',
    'form.zipCode',
    'form.city',
    'form.country',
    'form.birthDate',
    'form.birthCity',
    'form.birthCountry',
  ]),
  methods: {
    submit() {
      if (this.entityId) {
        this.update().then(this.returnToProfile);
      } else {
        const opportunityId = this.$route.params.id;
        this.create({ kind: 'Person', opportunityId }).then(() => {
          if (opportunityId) {
            this.$router.push('../confirmation');
          } else {
            this.returnToProfile();
          }
        });
      }
    },
  },
};
</script>
